module.exports = __webpack_public_path__ + "img/jk4.0608c05f.png";